import React from 'react';

export interface DataLayerProps {
  customScript?: string;
  pageEventData?: string;
}

export const DataLayer = ({ customScript, pageEventData }: DataLayerProps) => {
  const getScriptContent = () => {
    if (pageEventData) {
      return `var pageObject = ${pageEventData};
      if (pageObject) {
        ${customScript}
        window.dataLayer.push(pageObject);
      }`;
    }

    return '';
  };

  const scriptContent = `(function () {
    window.dataLayer = window.dataLayer || [];
    ${getScriptContent()}
  })();`;

  return (
    <script
      dangerouslySetInnerHTML={{
        __html: scriptContent,
      }}
    />
  );
};
